module.exports = __webpack_public_path__ + "img/kuaishou.b362e22d.jpg";